import React, { useEffect, useState } from 'react';

// handle resizing of window
// https://www.pluralsight.com/guides/re-render-react-component-on-window-resize
export function debounce(fn, ms) {
    let timer
    return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
        }, ms)
    };
}

// horizontal menu from https://codesandbox.io/s/react-horizontal-scrolling-menu-v2-dynamically-add-items-38ted?file=/src/index.tsx:1863-1869
export function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;
  
    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }
  
    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
}

// adapted from https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
export function useViewport() {
    // handle window resize
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setWidth(window.innerWidth);
        }, 300)

        window.addEventListener('resize', debouncedHandleResize)

        return _ => {
          window.removeEventListener('resize', debouncedHandleResize)
        }
    }, []);

    return { width };
}